import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControlValueAccessorComponent } from '../abstracts/form-control-value-accessor.abstract';

@Component({
	selector: 'app-input',
	templateUrl: './input.component.html',
	styleUrls: ['./input.component.scss'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: InputComponent,
			multi: true,
		},
	],
})
export class InputComponent extends AbstractFormControlValueAccessorComponent {
	// TODO: Update the the emitter based on values we need to pass in parent component.
	// TODO: Check why `blur` event is not emtting

	@Input() type: 'text' | 'number' | 'email' | 'password' = 'text';
	@Input() placeholder = '';
	@Input() errorMessage?: string;
	@Input() hint?: string;
	@Input() inputClass?: string;
	@Input() wrapperClass?: string;
	@Input() iconPrefix?: string;
	@Input() iconSuffix?: string;
	@Input() pattern?: string;
	@Input() isReadonly = false;
	@Input() maxLength = 524288;
	@Input() id?: string;

	// ngx-mask attributes (optional)
	@Input() mask = '';
	@Input() prefix = '';

	@Output() prefixClicked = new EventEmitter<void>();
	@Output() suffixClicked = new EventEmitter<void>();
	@Output() focused = new EventEmitter<void>();
	@ViewChild('inputField') inputField!: ElementRef; // Reference to the input field

	onFocus(): void {
		this.focused.emit();
	}

	onPrefixClick(): void {
		this.prefixClicked.emit();
	}

	onSuffixClick(): void {
		this.suffixClicked.emit();
	}

	focusOnInput(): void {
		if (this.inputField) {
			this.inputField.nativeElement.focus();
		}
	}
}
